<mat-dialog-content [ngClass.xs]="'w-mobile'" [ngClass.gt-xs]="'w-desktop'" class="text-center">
   <h4>Are you sure want to cancel subscription?</h4>
</mat-dialog-content>
<mat-dialog-actions class="justify-content-between">
  <button  mat-raised-button color="basic" (click)="onNoClick()">No</button>
  <button mat-raised-button color="primary" (click)="onYesClick()" >Yes, cancel subscription</button>
</mat-dialog-actions>
